import TermConfidentialityAndDataProtection1 from './list/TermConfidentialityAndDataProtection1'

export default function SecretaryTerms() {
  const terms = [TermConfidentialityAndDataProtection1()]

  return terms
}
